export default __webpack_public_path__ + "static/media/port7.411e7c51.jpg";